import { feature as systemInfoFeature } from '@central-products/system-info';
import { SystemInfoBrowserClient } from '@central-products/system-info-client';

export const systemInfoPlugin = {
  beforeBootstrap({ addBootstrapperFeature, params }) {
    const client = new SystemInfoBrowserClient();
    addBootstrapperFeature(systemInfoFeature, { ...params, client });
  },
};
